import React, { Component } from 'react';
import AccountItem from './components/AccountItem';
import { LoadingSpinner, ButtonLoaddingSpinner } from '../../components/Loading';
import Messages from '../../components/Messages';
import { Content } from '../../components/Content';
import { urls } from '../../utils/urls.config';




class AccountChoicesPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            uid: null,
            uri: null,
            token: null,
            choices: [],
            showError: false,
            errors: [],
            urlToSend: null,
            loading: false,
            submiting: false,
            hasAccount: false,
            accountCreated: false,
            message: '',
            details: '',
            itemSelected: false,
            fullName: '',
            termChecked: false
        };

    }

    componentWillMount() {
        let { uid, uri, token } = this.props.location.state;
        this.setState(
            {
                uid: uid,
                uri: uri,
                token: token,
            }, () => this.fetchChoices());
    }


    /* Busca as opções de conta institucional para o usuário logado */
    async fetchChoices() {
        let data = new FormData();
        data.append('user-uid', this.state.uid);

        this.setState({ loading: true });

        const response = await fetch(this.state.uri, {
            headers: new Headers({ 'Api-Token': 'Bearer ' + this.state.token }),
            method: 'POST',
            body: data,
        });

        const jsonResponse = await response.json();

        this.setState({ loading: false });

        if (jsonResponse.error) {
            this.setState({ showError: true, errors: [jsonResponse.error.message], details: jsonResponse.details });
            return;
        }

        this.setState({ choices: jsonResponse.choices.items, urlToSend: jsonResponse.links.href, fullName: jsonResponse.fullName });
    }


    handleSubmit = async (event) => {
        event.preventDefault();
        let data = new FormData(event.target);
        data.append('user-uid', this.state.uid);

        this.setState({ submiting: true });

        const response = await fetch(this.state.urlToSend, {
            headers: new Headers({
                'Api-Token': 'Bearer ' + this.state.token
            }),
            method: 'POST',
            body: data,
        })

        const jsonResponse = await response.json();

        this.setState({ submiting: false });

        if (!response.ok) {
            this.setState({ showError: true, errors: [jsonResponse.error.message] });
            return;
        }

        if (jsonResponse.error && jsonResponse.error.internal) {
            this.setState({ showError: true, errors: [jsonResponse.error.message] });
            return;
        }

        if (jsonResponse.error) {
            this.setState({ showError: true, errors: [jsonResponse.message], details: jsonResponse.details });
            return;
        }


        if (jsonResponse.accountCreated) {
            const { details, login, message } = jsonResponse;

            return this.props.history.push({
                pathname: urls.created.path,
                state: { details: details, login: login, message: message }
            })
        }

    };

    renderForm = (choices) => {
        const { itemSelected, termChecked } = this.state;
        const buttonProps = itemSelected && termChecked ? {} : { 'disabled': 'disabled' };
        const { fullName } = this.state;
        const firstName = fullName.split(' ')[0];

        //const toolTipDetails = <p>A criação de login da Conta Institucional seguem o padrão <strong>nome.sobrenome</strong> Em alguns casos, o sistema pode sugir algumas opções alternadas por não ter mais disponibilidade.</p>;
        return (
            <React.Fragment>
                <span className="text text-center text">
                    <h3 className="text-left">Olá {firstName}, <br />agora vamos criar a sua conta institucional! </h3>
                    <h5 className="text-left">
                        Abaixo listamos algumas opções de login diponíveis para sua conta institucional, escolha uma e clique em finalizar para concluir.
                        {/* <ToolTipInfo summary="opções de login">{toolTipDetails}</ToolTipInfo> */}                       
                    </h5>
                    <span className="text text-muted"><small>As opções de login foram baseadas no nome {fullName}</small></span>
                </span>
                <form onSubmit={this.handleSubmit} className="form-signin" method="POST" encType="application/json">
                    <fieldset className="form-group choices-item">
                        {choices}
                    </fieldset>
                    <div className="card bg-secondary text-white">
                        <div className="card-body">
                            A criação de login da Conta Institucional segue o padrão nome.sobrenome em atendimento à padronização definida pelo governo eletronico segundo o padrão e-Ping, para saber mais
                            <a href="http://governodigital.gov.br/documentos-e-arquivos/Padrao%20de%20Formacao%20de%20Enderecos%20de%20Correio%20Eletronico.pdf" target="_blank" rel="noopener noreferrer"> clique aqui.</a>
                            Em alguns casos, o sistema pode sugerir algumas opções alternadas por não haver mais disponibilidade.
                        </div>
                    </div>
                    <br />
                    <div>
                        <small>
                            Ao criar minhas credenciais de acesso único, concordo com as normas de uso e que uma vez escolhido e criado o login institucional o mesmo não poderá ser alterado.
                        </small>
                        <div className="form-check pt-2">
                            <input id="inp-checkbox-termo" className="form-check-input" type="checkbox" name="checkbox-termo" value="check" onClick={ (e) => this.setState({termChecked: !!e.target.checked})}/>
                            <label htmlFor="inp-checkbox-termo" className="pt-2 form-check-label">
                                Concordo com os termos para criação da conta institucional.
                            </label>
                        </div>
                    </div>

                    <br />
                    <div>
                        {this.state.submiting ? <ButtonLoaddingSpinner /> : <button className="btn btn-lg btn-primary btn-block" type="submit" {...buttonProps}>Finalizar</button>}
                    </div>
                </form>
            </React.Fragment>
        );
    }


    render() {
        const errors = this.state.errors.map((e, i) => <li key={i}>{e}</li>);
        const choices = this.state.choices.map((e, i) => (<AccountItem key={i} value={e} onClick={() => this.setState({ itemSelected: true })} />));
        const { loading, accountCreated, details, showError } = this.state;

        return (
            <Content stepName="Escolha sua conta" cancelButton={true}>
                {showError && <Messages.errorMessage errors={errors} details={details} />}
                {loading && <LoadingSpinner />}
                {(!accountCreated && !showError) && this.renderForm(choices)}                
            </Content>
        );
    }
}

export default AccountChoicesPage;